import React from "react";
import TextInputField from '../../../../helpers/TextInputField';
import DropDownField from '../../../../helpers/DropDownField'
import Button from "../../../../helpers/Button";

const EditState = () => {
    return(
        <div className="p-card">
            <h5>Edit State</h5>
            <div className="grid">
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <TextInputField name="stateName" labelText="State Name"  />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <DropDownField name="country" labelText="Country" Placeholder="please select a country" />
                </div>
            </div>
            <div className='mt-3 flex justify-content-end'>
                <Button label="Edit State"/>
            </div>
               
        </div>
    )
}
export default EditState;